// extracted by mini-css-extract-plugin
module.exports = {"upload-icon":"dd31006766--upload-icon--c3dej","input":"dd31006766--input--N2dpK","field":"dd31006766--field--sbGFA"};